import React from "react";
const Heart = ({ size, color, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || 20}
    height={size || 20}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={color || "#1c1c1c"}
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    opacity={0.2}
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);
export default Heart;
